/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { CourierPackage } from './CourierPackage';
/**
 * 
 * @export
 * @interface Manifest
 */
export interface Manifest {
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof Manifest
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Manifest
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    masterAwb?: string;
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    awbReference?: string;
    /**
     * 
     * @type {Date}
     * @memberof Manifest
     */
    dateReceived?: Date;
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof Manifest
     */
    createdOn?: Date;
    /**
     * 
     * @type {string}
     * @memberof Manifest
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof Manifest
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Manifest
     */
    courierId?: number;
    /**
     * Scan-in lifecycle status: open or closed
     * @type {string}
     * @memberof Manifest
     */
    scanStatus?: string;
    /**
     * Scheduled flight/shipment departure date
     * @type {Date}
     * @memberof Manifest
     */
    departureDate?: Date;

    /**
     *
     * @type {Array<CourierPackage>}
     * @memberof Manifest
     */
    courierPackages?: Array<CourierPackage>;
}

/**
 * Check if a given object implements the Manifest interface.
 */
export function instanceOfManifest(value: object): value is Manifest {
    return true;
}

export function ManifestFromJSON(json: any): Manifest {
    return ManifestFromJSONTyped(json, false);
}

export function ManifestFromJSONTyped(json: any, ignoreDiscriminator: boolean): Manifest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'masterAwb': json['masterAwb'] == null ? undefined : json['masterAwb'],
        'awbReference': json['awbReference'] == null ? undefined : json['awbReference'],
        'dateReceived': json['dateReceived'] == null ? undefined : (new Date(json['dateReceived'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdOn': json['createdOn'] == null ? undefined : (new Date(json['createdOn'])),
        'status': json['status'] == null ? undefined : json['status'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'scanStatus': json['scanStatus'] == null ? undefined : json['scanStatus'],
        'departureDate': json['departureDate'] == null ? undefined : (new Date(json['departureDate'])),
        'courierPackages': json['courierPackages'] == null ? undefined : json['courierPackages'],
    };
}

export function ManifestToJSON(json: any): Manifest {
    return ManifestToJSONTyped(json, false);
}

export function ManifestToJSONTyped(value?: Manifest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'masterAwb': value['masterAwb'],
        'awbReference': value['awbReference'],
        'dateReceived': value['dateReceived'] == null ? undefined : ((value['dateReceived']).toISOString()),
        'createdBy': value['createdBy'],
        'createdOn': value['createdOn'] == null ? undefined : ((value['createdOn']).toISOString()),
        'status': value['status'],
        'id': value['id'],
        'courierId': value['courierId'],
        'scanStatus': value['scanStatus'],
        'departureDate': value['departureDate'] == null ? undefined : ((value['departureDate']).toISOString()),
        'courierPackages': value['courierPackages'],
    };
}


